import React from 'react'
import { Card } from '@toasttab/shared/src/utils/craftUtils'
import { RestaurantCardProps } from './types.d'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import Badge from '@toasttab/shared/src/components/atoms/Badge/Badge'
import ImageResolutions from '@toasttab/shared/src/components/atoms/Image/ImageResolutions'

const RestaurantCard = ({
  badgeColor,
  badgeText,
  borderColor,
  ctaLabel,
  ctaLink,
  description,
  elevation,
  heading,
  images,
  linkIcons,
  list,
  padding = '16'
}: RestaurantCardProps) => {
  return (
    <div
      data-testid='restaurantcard'
      className={`restaurant-card rounded-md border bg-white ${Card.borderColor(
        borderColor
      )} ${Card.elevation(elevation)}`}
    >
      <div
        className={`${Card.cardPadding(padding)} flex flex-col justify-between`}
      >
        <div>
          {images ? (
            <ImageResolutions
              classes='mb-8'
              images={images}
              borderRadius={
                images.imageResolutions[0].borderRadius
                  ? images.imageResolutions[0].borderRadius.label
                  : 'None'
              }
              imageAlt={
                images.imageResolutions[0].desktop[0].title
                  ? images.imageResolutions[0].desktop[0].title
                  : null
              }
            />
          ) : null}
          {heading ? (
            <Typography as='h4' classes='mb-2' variation='h4'>
              {heading}
            </Typography>
          ) : null}
          {description ? (
            <Typography
              as='p'
              classes='pb-4 text-secondary'
              variation='default'
            >
              {description}
            </Typography>
          ) : null}
          {badgeText && badgeColor ? (
            <Badge badgeColor={badgeColor} classes='mb-5' text={badgeText} />
          ) : null}
          {list ? (
            <div>
              <ul className='pl-0 list-none'>
                {list.map((item: string, index: number) => {
                  return (
                    <li
                      key={index}
                      className={`font-normal text-base ${
                        list.length !== index + 1 ? 'mb-2' : ''
                      } text-secondary`}
                    >
                      {item}
                    </li>
                  )
                })}
              </ul>
            </div>
          ) : null}
        </div>
        {ctaLabel && ctaLink ? (
          <div className='mt-6'>
            <TextLink
              fontWeight={['font-semibold']}
              href={ctaLink}
              icon={linkIcons ? linkIcons : 'none'}
              text={ctaLabel}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default RestaurantCard
